import React, { useState, useEffect } from 'react';
import axios from 'axios';
import FormattedDate from '../../../utils/DateFormat'; // Función para formatear las fechas
import LoadingAnimation from '../../../components/anims/LoadingAnimation';

// Función para formatear valores como pesos colombianos
const formatCurrency = (value) => {
    return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP' }).format(value);
};

const capitalizeFirstLetter = (string) => {
    if (!string) return ''; // Maneja cadenas vacías o nulas
    return string.charAt(0).toUpperCase() + string.slice(1);
};

// Función para limitar los decimales de cantidad
const formatQuantity = (value) => {
    return parseFloat(value).toFixed(1);
};

const AuditoriaProducto = ({ id_producto, token }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchData = async () => {
        try {
            const response = await axios.get(`/api/productos/modificaciones/${id_producto}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            const { modifications, counts } = response.data;

            // Combina modificaciones y conteos
            const combinedData = [
                ...modifications.map((mod) => ({
                    tipo: 'modificacion',
                    ...mod,
                })),
                ...counts.map((count) => ({
                    tipo: 'conteo',
                    ...count,
                })),
            ].sort((a, b) => new Date(b.fecha_registro) - new Date(a.fecha_registro));

            setData(combinedData);
        } catch (err) {
            console.error(err);
            setError('Error al cargar los datos');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [id_producto]);

    if (loading) return <div><LoadingAnimation /></div>;
    if (error) return <div>{error}</div>;

    return (
        <div className="py-4 mx-auto overflow-y-auto max-h-[80vh]">
            {data.length === 0 ? ( // Verifica si no hay resultados
                <div className="text-center text-black-500 font-semibold text-lg">
                    No existen movimientos registrados.
                </div>
            ) : (
            <div className="space-y-4">
                {data.map((item, index) => (
                    <div
                        key={index}
                        className="p-4 bg-white shadow-md rounded-lg border border-yellow-500"
                    >
                        <p className="text-xs lg:text-sm text-gray-500">
                            {FormattedDate(item.fecha_registro)}
                        </p>
                        {item.tipo === 'modificacion' ? (
                            <div>
                                <h3 className="font-semibold mb-2 text-sm lg:text-base">
                                <span className='text-purple-500'>Modificación realizada por</span> {item.nombre_completo}
                                </h3>
                                <ul className="list-disc pl-8 text-xs md:text-sm">
                                {item.cambios.map((cambio, idx) => (
                                    <li key={idx}>
                                        <span className="font-semibold text-xs md:text-sm">
                                            {cambio.campo_modificado === 'precio_venta'
                                                ? 'Precio Venta'
                                                : capitalizeFirstLetter(cambio.campo_modificado)}
                                            :
                                        </span>{' '}
                                        {cambio.campo_modificado === 'precio_venta'
                                            ? `${formatCurrency(cambio.valor_anterior)} → ${formatCurrency(cambio.valor_nuevo)}`
                                            : `${cambio.valor_anterior} → ${cambio.valor_nuevo}`}
                                        {cambio.campo_modificado === 'precio_venta' && (
                                            <span className="text-xs lg:text-sm text-gray-500">
                                                {' '}
                                                (+ IVA S/A)
                                            </span>
                                        )}
                                    </li>
                                ))}
                            </ul>
                            </div>
                        ) : (
                            <div>
                                <h3 className="font-semibold mb-2 text-sm lg:text-base">
                                    <span className='text-orange-500'>Conteo realizado por</span> {item.nombre_empleado}
                                </h3>
                                <p className='text-xs md:text-sm'>
                                    <span className="font-semibold">Cantidad:</span>{' '}
                                    {formatQuantity(item.cantidad)}
                                </p>
                            </div>
                        )}
                    </div>
                ))}
            </div>
             )}
        </div>
    );
};

export default AuditoriaProducto;
